import { Button, Heading } from '@core/ui';
import { useRouter } from '@online-webinar/router';
import { Link } from '@online-webinar/ui-frontend';
import { Trans, useTranslation } from 'react-i18next';
import { AuthSideHeader } from '../../atoms';
import { AuthPage, AuthPageContent, AuthSideContent } from '../../organism';

export const PageNotFound = () => {
    const { t } = useTranslation();
    const router = useRouter();
    return (
        <AuthPage>
            <AuthPageContent>
                <Heading variant="h1" classNames="mb-4">
                    {t('Pages.404.Header')}
                </Heading>
                <p className="mb-6">{t('Pages.404.Text')}</p>
                <div className="flex gap-4">
                    <Link to="/" variant="primary">
                        {t('Generic.Link.WebinarSchedule')}
                    </Link>
                    <Button
                        onClick={(e) => {
                            e.preventDefault();
                            router.history.back();
                            return false;
                        }}
                        variant="primary-outline"
                    >
                        {t('Generic.Button.Back')}
                    </Button>
                </div>
            </AuthPageContent>

            <AuthSideContent>
                <AuthSideHeader>{t('Pages.404.SideContent.Header')}</AuthSideHeader>
                <Trans i18nKey="Pages.404.SideContent.Text" />
            </AuthSideContent>
        </AuthPage>
    );
};

export default PageNotFound;
